import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { Sol_HoursandtasksComponent } from '../sol-hours_and_tasks/sol-hours_and_tasks.component';
import { SolRiskComponent } from '../sol-risk/sol-risk.component';
import { SolMaterialComponent } from '../sol-material/sol-material.component';
import { SolOvertimePrevailingWageComponent } from '../sol-overtime-prevailing-wage/sol-overtime-prevailing-wage.component';
import { SolSubcontractorsComponent } from '../sol-subcontractors/sol-subcontractors.component';
import { SolBidDocumentationTabComponent } from '../sol-bid-documentation-tab/sol-bid-documentation-tab.component';
import { SolConditionsTabComponent } from '../sol-conditions-tab/sol-conditions-tab.component';
import { SolContractualDocumentationTabComponent } from '../sol-contractual-documentation-tab/sol-contractual-documentation-tab.component';
import { SolCostsLaborTabComponent } from '../sol-costs-labor-tab/sol-costs-labor-tab.component';
import { SolMarginsTabComponent } from '../sol-margins-tab/sol-margins-tab.component';
import { SolPMRequirementsTabComponent } from '../sol-pm-requirements-tab/sol-pm-requirements-tab.component';
import { SolPolicyExceptionTabComponent } from '../sol-policy-exceptions-tab/sol-policy-exceptions-tab.component';
import { SolSummaryTabComponent } from '../sol-summary-tab/sol-summary-tab.component';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonDataService } from '../../../services/common-data.service';
import { SolOtherTabComponent } from '../sol-other/sol-other.component';
import { SolCompleteChecklistTabComponent } from '../sol-complete-checklist/sol-complete-checklist.component';
import { Subject, takeUntil } from 'rxjs';
import { CostReviewEstimateType, ReviewDetailTabsService } from '../../../public-api';
import { ReviewService } from '../../../services/review.service';
import { Constants } from '../../../constants/constants';
import { CostReviewSecurityEnUsAttributes } from '../../../models/CostReviewSecurityEnUsAttributes';


@Component({
  selector: 'app-review-all-sol-tabs',
  imports: [MatTabsModule,
    Sol_HoursandtasksComponent,
    SolRiskComponent,
    SolMaterialComponent,
    SolOvertimePrevailingWageComponent,
    SolSubcontractorsComponent,
    SolBidDocumentationTabComponent,
    SolConditionsTabComponent,
    SolContractualDocumentationTabComponent,
    SolCostsLaborTabComponent,
    SolMarginsTabComponent,
    SolPMRequirementsTabComponent,
    SolPolicyExceptionTabComponent,
    SolSummaryTabComponent,
    SolOtherTabComponent,
    SolCompleteChecklistTabComponent,
    TranslatePipe
  ],
  templateUrl: './review-all-sol-tabs.component.html',
  styleUrl: './review-all-sol-tabs.component.scss',
  standalone: true
})
export class ReviewAllSolTabsComponent implements OnInit, OnDestroy {
  @Output() disablePdf = new EventEmitter<boolean>();
  selectedTabIndex = 0;

  private destroy$ = new Subject<void>();
  //if readOnlyMode is true it is used in MT otherwise in SQ web
  readOnlyMode: boolean = false;

  onDisablePdf(event: boolean) {
    this.disablePdf.emit(event);
  }

  constructor(
    private readonly commonDataService: CommonDataService,
    private readonly reviewDetailTabsService: ReviewDetailTabsService,
    private readonly reviewService: ReviewService) {}

  ngOnInit(): void {
    this.commonDataService.libraryReadOnlyMode$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((isReadOnly) => {
      const isLibraryUsedInSQ = this.reviewDetailTabsService.getIsLibraryUsedInSQ();
      this.readOnlyMode = !isLibraryUsedInSQ ? isReadOnly : false;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get isConditionsTabVisible(): boolean {
    const business = this.reviewService.getBusiness();
    if (business === Constants.BUSINESS_FIRE || business === Constants.BUSINESS_SECURITY) {
      return true;
    }

    const estimateType = this.reviewService.convertToEstimateType(
      this.reviewDetailTabsService.getOptionalWorkflowAndEstimateType().optionalEstimateType
    );
    return estimateType === CostReviewEstimateType.EstimateGreater150K;
  }

  get isPMRequirementTabVisible(): boolean {
    const reviewObject = this.reviewService.costReviewDetails?.reviewObject;
    return reviewObject?.costReviewProjectMgmtRequirements?.isProjectMgmtRequirementsApplicable ?? false;
  }
}
